import React, { Component } from "react";
import { Form, Field } from "redux-form";

class CreateFolderForm extends Component {
  render() {
    const disabled =
      this.props.invalid || this.props.submitting || this.props.pristine;

    return (
      <Form
        className="pa2 ph9 pv1"
        autoComplete="off"
        onSubmit={this.props.handleSubmit}
      >
        {this.props.error && (
          <div className="form__error">{this.props.error}</div>
        )}
        <Field
          className="form__field"
          name="title"
          component="input"
          type="text"
          placeholder={this.props.t("modals:exArchitectForm")}
        />

        <div className="mt2 tc">
          {/* cancel */}
          <button
            type="button"
            className="button mr3"
            onClick={this.props.handleCancel}
          >
              {this.props.t("common:cancelButton")}
          </button>

          {/* submit */}
          <button className="button" disabled={disabled} type="submit">
            {this.props.t("common:createButton")}&nbsp;<i className="i-arrow-right f7" />
          </button>
        </div>
      </Form>
    );
  }
}

export default CreateFolderForm;



// WEBPACK FOOTER //
// ./src/components/forms/CreateFolderForm.js